module.exports = __webpack_public_path__ + "static/media/handraise.8e546d10.jpg";